import { render, staticRenderFns } from "./PraticaDocuments.vue?vue&type=template&id=0601e2bb&scoped=true&"
import script from "./PraticaDocuments.vue?vue&type=script&lang=js&"
export * from "./PraticaDocuments.vue?vue&type=script&lang=js&"
import style0 from "./PraticaDocuments.vue?vue&type=style&index=0&id=0601e2bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0601e2bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0601e2bb')) {
      api.createRecord('0601e2bb', component.options)
    } else {
      api.reload('0601e2bb', component.options)
    }
    module.hot.accept("./PraticaDocuments.vue?vue&type=template&id=0601e2bb&scoped=true&", function () {
      api.rerender('0601e2bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaDocuments.vue"
export default component.exports